import type { TypePolicies } from '@apollo/client';

import {
    mailOrderProviderFields,
    medicationFields,
    patientFields,
    pharmacyProviderFields,
    prescriberFields,
} from './index';

export const LillyDirectTypePolicies: TypePolicies = {
    Patient: {
        merge: true,
        fields: {
            ...patientFields,
        },
    },
    Medication: {
        fields: {
            ...medicationFields,
        },
    },
    PrescriberOrderPrescriber: {
        merge: true,
        fields: {
            ...prescriberFields,
        },
    },
    MailOrderProvider: {
        fields: {
            ...mailOrderProviderFields,
        },
    },
    PharmacyProvider: {
        fields: {
            ...pharmacyProviderFields,
        },
    },
};
